<style scoped>
    @import url("../../styles/quemSomos/sobrenos.scss");
</style>

<template>
    
    <div class="box_sobrenos" v-if="!$store.state.flagMenuSup">

        <div class="painel_quemSomos mb-4">

            <div class="line_btnToBack mt-4" @click="backToMain()"
            @mouseover="hoverBackInit = 'rgb(31,122,177)'"
            @mouseleave="hoverBackInit = '#f39c12'"
            >
                <v-icon large class="mr-2" :style="{'color':hoverBackInit}">mdi-arrow-left-thick</v-icon>
                <span>Voltar</span>
            </div>

            <div class="line_tit">
                <v-icon large class="mr-2" :style="{'color':'#4B94C0'}">mdi-account-group</v-icon>
                <span>Sobre nós</span>
            </div>

            <div class="painelMainContent">

                <ImgLinhaBQuemSomos />

                <div class="body1">

                    <div class="col_esq_body1 mt-2">

                        <span>{{ f1 }}</span>

                        <v-icon @click="callInstagramMaker()"
                        small :style="{'align-self':'flex-start','color':hoverInstagramMaker,'cursor':'pointer'}"
                        @mouseover="hoverInstagramMaker = '#f39c12'"
                        @mouseleave="hoverInstagramMaker = 'rgb(31,122,177)'"
                        >mdi-arrow-top-right-thin-circle-outline</v-icon>
                        
                        <span class="mt-2">{{ f2 }}</span>
                        <span class="mt-2">{{ f3 }}</span>
                        <span class="mt-2">{{ f4 }}</span>

                    </div>

                    <!--<div class="col_dir_body1">
                        <v-img 
                        :style="{'min-height':'400px','border-radius':'8px'}" 
                        :src="require('../../assets/qs1.jpeg')"
                        ></v-img>
                    </div>-->

                </div>

            </div>

            <div class="body2">

                <div @click="callInstagram()"
                @mouseover="hoverInstagramOficial = '#f39c12'"
                @mouseleave="hoverInstagramOficial = 'rgb(31,122,177)'"
                >
                    <v-icon large class="mr-2" :style="{'color':hoverInstagramOficial}">mdi-instagram</v-icon>
                    <span>UPinC.Oficial</span>
                </div>

                <div @click="callLinkedin()"
                @mouseover="hoverLinkedin = '#f39c12'"
                @mouseleave="hoverLinkedin = 'rgb(31,122,177)'"
                class="mt-4"
                >
                    <v-icon large class="mr-2" :style="{'color':hoverLinkedin}">mdi-linkedin</v-icon>
                    <span>UPinC Tecnologia IoT</span>
                </div>
            </div>

        </div>
            
    </div>

</template>

<script>
//import MenuSupMainV2 from '../mainV2/MenuSupMainV2'
//import MenuBodyMainV2 from '../mainV2/MenuBodyMainV2'

import ImgLinhaBQuemSomos from './ImgLinhaBQuemSomos'

export default {

    components:{/*MenuSupMainV2, MenuBodyMainV2,*/ ImgLinhaBQuemSomos},
    
    data() {
        return {
            // estrutural menu. via store desde 03/09/2024
            //flagMenuSup:false,

            hoverBackInit:'#f39c12', // -- init laranja
            hoverInstagramMaker:'rgb(31,122,177)', // -- init azul
            hoverInstagramOficial:'rgb(31,122,177)',
            hoverLinkedin:'rgb(31,122,177)',

            f1:'A UPinC nasceu como uma iniciativa entre amigos, movidos pela paixão pela cultura maker e pelo potencial transformador da tecnologia. Inicialmente, surgiu como UPinC Makers, um espaço de colaboração e aprendizagem na cidade da Covilhã, dedicado a explorar e impulsionar soluções inovadoras.',
            f2:'Com o crescimento da nossa visão e da demanda por soluções tecnológicas acessíveis, a UPinC consolidou-se como empresa no município do Fundão. Hoje, somos responsáveis pelas redes de antenas LoRa da cidade, garantindo conectividade eficiente e soluções de comunicação para diversos setores.',
            f3:'O nome UPinC ("UP in Circle") remete ao sinal de ondas de rádio, simbolizando nossa missão de levar a tecnologia IoT (Internet das Coisas) a novos patamares. A IoT oferece um universo vasto de possibilidades para otimizar a vida e o trabalho das pessoas, mas identificamos que essa tecnologia ainda não é acessível para todos. Muitas pequenas e médias empresas enfrentam dificuldades para adotar essas soluções devido à falta de informação ou à incapacidade das grandes empresas de atender demandas específicas.',
            f4:'Por isso, especializamo-nos em LoRaWAN, uma tecnologia de comunicação de longo alcance e baixo consumo energético, ideal para conectar dispositivos inteligentes e captar dados em larga escala. Nosso compromisso é democratizar o acesso a essas soluções, viabilizando a inovação e a eficiência para empresas e comunidades que desejam aproveitar o poder da conectividade inteligente.',
        }
    },

    methods: {
        //
        backToMain() { this.$router.push('/'); },
        goToAgro() { this.$router.push('/agro'); },
        goToFabr() { this.$router.push('/loja'); },
        goToAutomation() { this.$router.push('/automation'); },
        callInstagramMaker() { window.open("https://www.instagram.com/upinc.makers/"); },
        callInstagram() { window.open('https://www.instagram.com/upinc.oficial/'); },
        callLinkedin() { window.open("https://www.linkedin.com/company/upinc-iot/?viewAsMember=true"); },

        returnFromMenu(flagStringMenuSmall) {

            if (flagStringMenuSmall == 'open') {

                //console.log('abrir menu')
                this.flagMenuSup = true
            
            } else {
                //console.log('fechar menu')
                this.flagMenuSup = false
            }
        },
    },

    created() {
        //this.$store.commit('srcIP') // without param. Initial main GET Req.
        window.scrollTo(0,0)
    }
}

</script>